import React from "react";
import Footer from "../Component/Footer";
import imageFour from "../image/istockphoto-169982509-612x612.jpg";
import image from "../image/laundry-dry-cleaning-service.jpg";
import imageThree from "../image/photo-business-shirt-background-industrial-washing-machine_950002-553292.jpg";
import imageOne from "../image/shutterstock_1019057059.jpg";

function About() {
  return (
    <>
      <div
        id="subtitle-wrapper"
        className="lazyload"
        data-bg="image/subtitle-wrapper01.jpg"
      >
        <div
          className="subtitle-wrapper-img lazyload"
          data-bg="image/subtitle-wrapper01-img.jpg"
        >
          <div className="container container-fluid-xl">
            <div className="tt-breadcrumbs">
              <ul>
                <li>
                  <a href="index.html">home</a>
                </li>
                <li>About Us</li>
              </ul>
            </div>
            <h1 className="subtitle__title">About Us</h1>
          </div>
          <div className="bubbleContainer">
            <div className="bubble-1"></div>
            <div className="bubble-2"></div>
            <div className="bubble-3"></div>
            <div className="bubble-4"></div>
            <div className="bubble-5"></div>
            <div className="bubble-6"></div>
            <div className="bubble-7"></div>
            <div className="bubble-8"></div>
            <div className="bubble-9"></div>
            <div className="bubble-10"></div>
          </div>
        </div>
      </div>
      <main id="tt-pageContent">
        <div
          className="lazyload subpage-bg-left subpage-bg__position01"
          data-bg="image/wrapper-subpage-left01.png"
        >
          <div
            className="lazyload subpage-bg-right subpage-bg__position01"
            data-bg="image/wrapper-subpage-right.png"
          >
            <div className="section-indent">
              <div className="container container-fluid-lg">
                <div className="layout01">
                  <div className="layout01__img">
                    <img className="tt-arrow" src={imageThree} alt="" />
                    <div className="tt-img-main">
                      <img
                        src={imageOne}
                        data-src="image/layout01-img01.jpg"
                        className="lazyload"
                        alt=""
                      />
                    </div>
                    <div className="tt-img-more left-bottom">
                      <img
                        src={image}
                        data-src="image/layout01-img02.jpg"
                        className="lazyload"
                        alt=""
                      />
                    </div>
                  </div>
                  <div className="layout01__content">
                    <div className="layout01__content-wrapper">
                      <div className="title-block">
                        <div className="title-block__label">
                          [ More than 25 Years of Experience ]
                        </div>
                        <h4 className="title-block__title">
                          Your Dry Cleaning and Laundry. Done.
                        </h4>
                      </div>
                      <p>
                        We are professionals in the laundry and dry cleaning
                        business, which means we always stay up to date on the
                        latest technologies, cleaning methods, and solutions for
                        dealing with stains or delicate fabrics. Plus, we
                        maintain the highest standards of business integrity by
                        following local and national regulations and
                        environmental safety rules. We are passionate about
                        changing the way you think about laundry!
                      </p>
                      <ul className="tt-list01 tt-list01__top">
                        <li>100% Customer Satisfaction</li>
                        <li>Free Collection & Delivery</li>
                        <li>Affordable Prices</li>
                        <li>Best Quality</li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="box-value__wrapper row" id="counter-js">
                  <div className="col-sm-6 col-xl-3">
                    <div className="box-value">
                      <div className="box-value__icon icons-3096677"></div>
                      <div className="box-value__content">
                        <div className="box-value__value">
                          <span
                            className="tt-counter"
                            data-from="0"
                            data-to="50000"
                          >
                            0
                          </span>
                          +
                        </div>
                        <div className="box-value__label">Shirts Washed</div>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-6 col-xl-3">
                    <div className="box-value">
                      <div className="box-value__icon icons-2840421"></div>
                      <div className="box-value__content">
                        <div className="box-value__value">
                          <span
                            className="tt-counter"
                            data-from="0"
                            data-to="50"
                          >
                            0
                          </span>
                        </div>
                        <div className="box-value__label">Washing Machines</div>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-6 col-xl-3">
                    <div className="box-value">
                      <div className="box-value__icon icons-hanger-with-clothes"></div>
                      <div className="box-value__content">
                        <div className="box-value__value">
                          <span
                            className="tt-counter"
                            data-from="0"
                            data-to="10000"
                          >
                            0
                          </span>
                          +
                        </div>
                        <div className="box-value__label">
                          Dry Cleaned Items
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-6 col-xl-3">
                    <div className="box-value">
                      <div className="box-value__icon icons-1545560"></div>
                      <div className="box-value__content">
                        <div className="box-value__value">
                          <span
                            className="tt-counter"
                            data-from="0"
                            data-to="100"
                          >
                            0
                          </span>
                          %
                        </div>
                        <div className="box-value__label">Happy Customers</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div className="container-fluid no-gutters">
                <div className="box02 box02__img-right box02-notover">
                  <div className="box02__img">
                    <img
                      src={imageFour}
                      className="lazyload"
                      data-src="image/box02-img04.jpg"
                      alt=""
                    />
                    <img
                      className="tt-arrow"
                      src="image/arrow-img-left02.png"
                      alt=""
                    />
                  </div>
                  <div className="box02__content box02__content-variant02">
                    <div className="title-block">
                      <div className="title-block__label">
                        [ Our Guarantee ]
                      </div>
                      <h4 className="title-block__title">
                        The Best Guarantee
                        <br />
                        in the Business
                      </h4>
                    </div>
                    <p>
                      The most trusted brand in clothing care since 2011. We
                      will do everything we can to return your clothes to you in
                      great shape. In the rare instance that an item goes
                      missing or is damaged during the cleaning process, we’ll
                      reimburse you up to the full value of the item with a
                      $1,000 maximum per order.
                    </p>
                    <a
                      href="#"
                      className="tt-btn tt-btn__top"
                      data-toggle="modal"
                      data-target="#modalMRequestQuote"
                    >
                      <span className="mask">Get Service Now</span>
                      <div className="button">Get Service Now</div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div style={{ marginBottom: "50px" }}>
              <div className="container container-fluid-lg">
                <div className="title-block text-center">
                  <div className="title-block__label">[ Our Advantages ]</div>
                  <h4 className="title-block__title">Why Choose Us</h4>
                </div>
                <div className="added-info02 row">
                  <a
                    href="contact-areas.html"
                    className="added-info02__item col-md-4"
                  >
                    <div className="added-info02__icon icons-bright-lightbulb"></div>
                    <div className="added-info02__description">
                      <h6 className="added-info02__title">
                        <span>Persionalized Experience</span>
                      </h6>
                      We take utmost care of your clothes, segregating based on
                      the cloth type and giving you instant clothes to make a
                      statement.
                    </div>
                  </a>
                  <a
                    href="contact.html"
                    className="added-info02__item col-md-4"
                  >
                    <div className="added-info02__icon icons-tag-1"></div>
                    <div className="added-info02__description">
                      <h6 className="added-info02__title">
                        <span>Affordable Pricing</span>
                      </h6>
                      Prices that suit your pocket are one of our USPs. An
                      option of choosing between 2 types of pricing is
                      available.
                    </div>
                  </a>
                  <a href="#" className="added-info02__item col-md-4">
                    <div className="added-info02__icon icons-reading-book"></div>
                    <div className="added-info02__description">
                      <h6 className="added-info02__title">
                        <span>Convenience</span>
                      </h6>
                      With just a tap of a button, your laundry gets done,
                      giving your leisure time to spend with family and friends.
                    </div>
                  </a>
                  <a href="#" className="added-info02__item col-md-4">
                    <div className="added-info02__icon icons-3022225"></div>
                    <div className="added-info02__description">
                      <h6 className="added-info02__title">
                        <span>Quality</span>
                      </h6>
                      We use the best in class products, to assure that your
                      favorite clothes are always there for you to wear.
                    </div>
                  </a>
                  <a href="#" className="added-info02__item col-md-4">
                    <div className="added-info02__icon icons-fast-delivery"></div>
                    <div className="added-info02__description">
                      <h6 className="added-info02__title">
                        <span>Quick Service</span>
                      </h6>
                      We deliver within hours, depending on the distance.
                    </div>
                  </a>
                  <a href="#" className="added-info02__item col-md-4">
                    <div className="added-info02__icon icons-medal"></div>
                    <div className="added-info02__description">
                      <h6 className="added-info02__title">
                        <span>100% Satisfaction Guarantee</span>
                      </h6>
                      We assure the satisfaction of our customers with
                      guaranteed quality service.
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}

export default About;
